import { FC } from 'react'
import ProducerCard from 'components/producers/producer-card/ProducerCard'
import { ProducerMapMarkerProps as Props } from './types'
import EnergyTypeIcon from '../energy-type-icon/EnergyTypeIcon'
import { useRouter } from 'next/router'
import styles from './ProducerMarker.module.scss'
import classNames from 'classnames'

const ProducerMarker: FC<Props> = ({ producer, onMouseEnter, onMouseLeave, active, popup, onClick, index }) => {
  // Next router
  const { locale } = useRouter()

  return (
    <>
      {popup ? (
        <div className={styles['producer-marker-card']}>
          <ProducerCard producer={producer} showDescription={false} />
        </div>
      ) : (
        <div
          className={classNames(styles['producer-marker'], { [styles['is-active']]: active })}
          onMouseEnter={() => onMouseEnter && onMouseEnter(producer, index)}
          onMouseLeave={() => onMouseLeave && onMouseLeave()}
          onClick={(event) => {
            event.stopPropagation()
            if (onMouseLeave) onMouseLeave()
            if (onClick) onClick(producer, index)
          }}
          role="presentation"
        >
          <EnergyTypeIcon energyType={producer.energyType} forMarker />
          &nbsp;
          {active && <span className={styles.name}>{producer.name[locale]}</span>}
        </div>
      )}
    </>
  )
}

export default ProducerMarker
